export const imageGetters = {
  getImage(state) {
    return state.image
  },
  getActiveLibrary() {
    return this.activelibrary
  }
}
